import PdpLayout from "@/components/pdp/PdpLayout";
import { EYE_REPAIR_V33 } from "@/data/eyeRepairV33";

export default function PdpConceptV33() {
  return <PdpLayout data={EYE_REPAIR_V33} />;
}
